module.exports = __webpack_public_path__ + "img/restaurante.13ea83a0.svg";